const formatValueFloat = value =>
  Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(value);

export { formatValueFloat };
